import { useEffect, useState } from 'react';
import produce from 'immer';

import { excelDownLoad } from '../../../../../../lib/common';
import toastMsg from '../../../../../../lib/toastMsg';
import { LIST_PAGINATION_MODEL } from '../../../../../../store/modules/app/models';
import {
  COUPON_LIST_FILTER_OPTION_MODEL,
  COUPON_LIST_SORT_OPTION_MODEL,
} from '../../../../../../store/modules/coupon/models';
import couponToastMsg from '../../../../../../constants/service/toastMsg/couponToastMsg';
import { useCouponListExcelDownloadMutate, useUserDetailGenerateCouponQuery } from './query';

export const useUserDetailGenerateCoupon = ({ userId }) => {
  const [pagination, setPagination] = useState(LIST_PAGINATION_MODEL);
  const [filterOption, setFilterOption] = useState(COUPON_LIST_FILTER_OPTION_MODEL);
  const [sortOption, setSortOption] = useState(COUPON_LIST_SORT_OPTION_MODEL);
  const [couponListState, setCouponListState] = useState({ couponList: [], totalCnt: 0 });

  const { data } = useUserDetailGenerateCouponQuery({
    userId,
    pagination,
    filterOption,
    sortOption,
    options: {
      enabled: !!userId,
      onSuccess: () => toastMsg.success(couponToastMsg.GET_ISSUED_COUPON_LIST_REQUEST_SUCCESS),
      onError: (error) => {
        toastMsg.error(error.message);
      },
      select: (result) => ({
        couponList: result.data.couponList.map((item) => ({ ...item, issuedCount: 1 })),
        totalCnt: result.data.totalCnt,
      }),
    },
  });

  const handleIssuedCount = (index, value) => {
    setCouponListState((prevData) =>
      produce(prevData, (draft) => {
        draft.couponList[index].issuedCount = value;
      }),
    );
  };

  const getList = ({ filterOption, sortOption, pagination }) => {
    filterOption && setFilterOption(filterOption);
    sortOption && setSortOption(sortOption);
    pagination && setPagination(pagination);
  };

  useEffect(() => {
    if (data.couponList.length > 0) {
      setCouponListState({
        couponList: data.couponList,
        totalCnt: data.totalCnt,
      });
    }
  }, [data]);

  return {
    data: couponListState,
    pagination: { ...pagination, pages: Math.ceil(couponListState.totalCnt / pagination.pageSize) },
    filterOption,
    sortOption,
    getList,
    handleIssuedCount,
  };
};

export const useCouponListExcelDownload = () => {
  const { mutate } = useCouponListExcelDownloadMutate({
    options: {
      onSuccess: (result) => {
        toastMsg.success(couponToastMsg.GET_COUPON_LIST_REQUEST_SUCCESS);

        excelDownLoad('쿠폰 리스트', result.data.couponListExcelSheet);
      },
      onError: (error) => {
        toastMsg.error(error.message);
      },
    },
  });

  return { getCouponListExcelDownload: mutate };
};
